<template>
    <v-container fluid fill-height>
        <v-row justify="center">
            <v-col cols="6" align-self="center">
                <v-card>
                    <v-card-title>
                        Income Statements
                    </v-card-title>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import DynamicToolbar from '@/components/Global/Utils/DynamicToolbar.vue';
export default {
    components: {
        DynamicToolbar
    },
    data() {
        return {
            loading: false
        };
    }
};
</script>
